/** @format **/
import React, { PureComponent } from "react";
import Avatar from "@material-ui/core/Avatar";
import Button from "@material-ui/core/Button";
import Fab from "@material-ui/core/Fab";
import IconButton from "@material-ui/core/IconButton";
import Tooltip from "@material-ui/core/Tooltip";
import Typography from "@material-ui/core/Typography";
import classNames from "classnames";
import { withRouter } from "react-router-dom";
import { withStyles } from "@material-ui/core/styles";

const styles = theme => ({
  bold: {
    fontWeight: 700
  },
  button: {
    padding: theme.spacing(1),
    flexShrink: 0
  },
  labelButton: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center"
  },
  labelButtonHoriz: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center"
  },
  smallerFont: {
    fontSize: "50%"
  },
  ...theme.overrides.NavItem
});

class NavItem extends PureComponent {
  onClick = e => {
    e.preventDefault();
    this.props.url &&
      this.props.history.push(
        this.props.history.location.search === "?preview"
          ? {
              pathname: this.props.url,
              search: this.props.history.location.search
            }
          : this.props.url
      );
  };

  render() {
    const {
      props: {
        tooltip,
        bold,
        url,
        children,
        icon: Icon,
        onClick,
        classes,
        className,
        match,
        location,
        history,
        staticContext,
        push,
        text,
        fab,
        horiz,
        avatar,
        ...props
      }
    } = this;

    let rslt;

    if (Icon) {
      rslt = (
        <IconButton color="inherit" onClick={onClick || this.onClick}>
          <div
            className={classNames(
              horiz ? classes.labelButtonHoriz : classes.labelButton,
              className
            )}
            {...props}
          >
            {avatar ? (
              <Avatar>
                <Icon />
              </Avatar>
            ) : (
              <Icon />
            )}

            <Typography component="span" className={classes.smallerFont}>
              {children}
            </Typography>
          </div>
        </IconButton>
      );
    } else if (text) {
      rslt = (
        <Typography
          component="div"
          color="inherit"
          className={classNames(
            bold && classes.bold,
            classes.button,
            className
          )}
          {...props}
        >
          {children}
        </Typography>
      );
    } else if (fab) {
      rslt = (
        <Fab
          component="div"
          color="inherit"
          className={classNames(classes.button, className)}
          href={url}
          onClick={onClick || this.onClick}
        >
          <Typography
            component="span"
            color="inherit"
            noWrap
            className={bold && classes.bold}
            {...props}
          >
            {children}
          </Typography>
        </Fab>
      );
    } else {
      rslt = (
        <Button
          component="div"
          color="inherit"
          className={classNames(classes.button, className)}
          href={url}
          onClick={onClick || this.onClick}
        >
          <Typography
            component="span"
            color="inherit"
            noWrap
            className={bold && classes.bold}
            {...props}
          >
            {children}
          </Typography>
        </Button>
      );
    }

    if (tooltip) {
      return (
        <Tooltip enterDelay={750} leaveDelay={200} {...tooltip}>
          {rslt}
        </Tooltip>
      );
    }

    return rslt;
  }
}

export default withStyles(styles, { name: "LcNavItem" })(withRouter(NavItem));
